"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _reactCsv = require("react-csv");

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _shapes = require("@cimpress/react-components/lib/shapes");

var _emotion = require("emotion");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LOADING = 'LOADING';
var AVAILABLE = 'AVAILABLE';
var UNAVAILABLE = 'UNAVAILABLE';
var errorStyle = (0, _emotion.css)(_templateObject(), _reactComponents.colors.danger.darker);

var CsvLinkDownload =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CsvLinkDownload, _PureComponent);

  function CsvLinkDownload() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CsvLinkDownload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CsvLinkDownload)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      data: [],
      status: AVAILABLE
    };
    _this.csvLink = _react.default.createRef();

    _this.fetchData = function () {
      var getData = _this.props.getData;

      _this.setState({
        status: LOADING
      });

      Promise.resolve(getData()).then(function (data) {
        _this.setState({
          data: data,
          status: AVAILABLE
        }, function () {
          // click the CSVLink component to trigger the CSV download
          _this.csvLink.current.link.click();
        });
      }).catch(function () {
        _this.setState({
          status: UNAVAILABLE
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(CsvLinkDownload, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          linkText = _this$props.linkText,
          fileName = _this$props.fileName;
      var _this$state = this.state,
          data = _this$state.data,
          status = _this$state.status;
      var display;

      switch (status) {
        case LOADING:
          display = _react.default.createElement(_shapes.Spinner, {
            size: 20
          });
          break;

        case AVAILABLE:
          display = _react.default.createElement(_reactComponents.Button, {
            type: "link",
            onClick: this.fetchData
          }, linkText);
          break;

        default:
          display = _react.default.createElement("small", {
            className: errorStyle
          }, "Error Loading Data to Download");
          break;
      }

      return _react.default.createElement("div", null, display, _react.default.createElement(_reactCsv.CSVLink, {
        data: data,
        filename: fileName,
        className: "hidden",
        ref: this.csvLink,
        target: "_blank"
      }));
    }
  }]);
  return CsvLinkDownload;
}(_react.PureComponent);

var _default = CsvLinkDownload;
exports.default = _default;